import { PublicationProfileCardController } from './controllers/PublicationProfileCardController.js';
import { BasePage } from '../../base/BasePage.js';

export class PublicationCreatePage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const cp = window.appData?.cp;
        const authorId = window.appData?.authorId;

        this.initResource({
            controller: new PublicationProfileCardController(),
            event: 'publication.profileCard',
            cacheKey: `publication.profileCard.${cp}`,
            payload: { token, locale, authorId }
        });
    }
}